// lib/slices/createCartSlice.ts
import { data as flavorData } from "../../components/BYBFlow/PDP/FlavorPicker";
import { PROTEIN } from "../../components/BYBFlow/PDP/data";
import structuredClone from "@ungap/structured-clone";
export const removalPriorityDesc = [
    "variety",
    "caramel",
    "chocolate",
    "cinnamon",
    "cookies",
    "mocha",
    "peanut",
    "strawberry",
    "vanilla",
];
function mergeAndAdd(obj1, obj2) {
    const result = {};
    // Loop through keys of obj1
    // eslint-disable-next-line
    for (const key in obj1) {
        result[key] = obj1[key];
    }
    // Loop through keys of obj2
    for (const key in obj2) {
        if (result[key]) {
            result[key] += obj2[key];
        }
        else {
            result[key] = obj2[key];
        }
    }
    return result;
}
export const mapServerProductToClient = (product) => {
    let flavor;
    const flavorMap = {
        mango: "Mango",
        lemonlime: "Lemon Lime",
        strawberrylemonade: "Strawberry Lemonade",
        strawberry: "Strawberry",
        watermelon: "Watermelon",
        lemonginger: "Lemon Ginger",
        tropicalpineapple: "Tropical Pineapple",
    };
    if (product.flavor) {
        flavor = flavorMap[product.flavor];
    }
    let category = product.item_category;
    if (category.toLowerCase() === "personalized") {
        category = "customized";
    }
    return {
        customizations: product.customizations,
        category,
        type: product.item_type,
        image: product.image_url,
        title: product.title,
        productId: product.product_id,
        price: product.product_price,
        quantity: 1,
        flavor,
        nutrition_facts_image: product.nutrition_facts_image,
        unit_prices: product.unit_prices,
    };
};
export const formatFlavorBoostsString = (chosenFlavors) => {
    const fullFlavorNames = Object.keys(chosenFlavors)
        .filter((sku) => !!chosenFlavors[sku])
        .map((sku) => {
        const flavorDataItem = flavorData.find((item) => sku === item.sku);
        return (flavorDataItem?.name +
            (chosenFlavors[sku] > 1 ? ` x${chosenFlavors[sku]}` : ""));
    })
        .join(", ");
    return fullFlavorNames;
};
export const createCartSlice = (set, get) => ({
    // state
    cart: [],
    showCart: false,
    hasHadCart: false,
    // actions
    addToCart: (product) => {
        const cart = structuredClone(get().cart);
        const findProduct = cart.find((p) => p.productId === product.productId);
        if (findProduct) {
            findProduct.quantity += product.quantity;
            // if protein
            // add findProduct's flavors to newProduct's flavors
            if (findProduct.title.toLowerCase().includes("protein")) {
                const oldFlavorsDict = structuredClone(findProduct.formValues?.[PROTEIN].FLAVORS);
                const newFlavorsDict = structuredClone(product.formValues?.[PROTEIN].FLAVORS);
                const newNewFlavorsDict = mergeAndAdd(oldFlavorsDict, newFlavorsDict);
                if (findProduct.formValues) {
                    findProduct.formValues.PROTEIN.FLAVORS = newNewFlavorsDict;
                    findProduct.flavor = formatFlavorBoostsString(newNewFlavorsDict);
                }
            }
        }
        else {
            cart.unshift(product);
        }
        set({ cart });
        set({ hasHadCart: true });
    },
    removeFromCart: (productId) => {
        set({
            cart: get().cart.filter((product) => product.productId !== productId),
        });
    },
    updateQuantity: (productId, action, isProtein = false) => {
        let cart = structuredClone(get().cart);
        const findProduct = cart.find((p) => p.productId === productId);
        if (findProduct) {
            const flavorsDict = structuredClone(findProduct.formValues?.[PROTEIN].FLAVORS);
            if (action === "decrease") {
                if (findProduct.quantity === 1) {
                    // remove item from cart
                    cart = cart.filter((product) => product.productId !== productId);
                }
                else if (findProduct.quantity > 1) {
                    findProduct.quantity -= 1;
                    if (isProtein && flavorsDict) {
                        for (let i = 0; i < 2; i += 1) {
                            // remove skus in the following order
                            const flavorSkus = removalPriorityDesc.filter((flavorSku) => flavorsDict[flavorSku]);
                            flavorsDict[flavorSkus[0]] -= 1;
                        }
                    }
                }
            }
            else {
                findProduct.quantity += 1;
                if (isProtein && flavorsDict?.variety) {
                    flavorsDict.variety += 2;
                }
                else if (isProtein && flavorsDict) {
                    flavorsDict.variety = 2;
                }
            }
            if (findProduct.formValues?.[PROTEIN] && isProtein && flavorsDict) {
                findProduct.flavor = formatFlavorBoostsString(flavorsDict);
                findProduct.formValues[PROTEIN].FLAVORS = flavorsDict;
            }
        }
        set({ cart });
    },
    toggleCart: () => {
        set({ showCart: !get().showCart });
    },
    clearCart: () => {
        set({ cart: [] });
    },
    getTotal: () => {
        return get().cart.reduce((acc, product) => {
            return acc + product.price * product.quantity;
        }, 0);
    },
    getDeliveryProgress: () => {
        const FREE_DELIVERY = 60;
        const total = get().getTotal() / 100;
        const value = Math.min(100, Math.round((total / FREE_DELIVERY) * 100));
        return {
            value,
            amount: FREE_DELIVERY - total < 0 ? 0 : FREE_DELIVERY - total,
        };
    },
});
